module.exports = __webpack_public_path__ + "static/media/hqv_zoom_finger.46e8305f.gif";